/**
 * Agent 技能市场 — Mock API
 * 扩展你的AI能力边界
 */

// —— 分类定义 ——
export const categories = [
  { key: 'all', label: '全部', icon: 'AppsOutlined' },
  { key: 'featured', label: '官方推荐', icon: 'StarOutlined' },
  { key: 'content', label: '内容创作', icon: 'EditOutlined' },
  { key: 'advertising', label: '广告投放', icon: 'RocketOutlined' },
  { key: 'analytics', label: '数据分析', icon: 'BarChartOutlined' },
  { key: 'influencer', label: '达人营销', icon: 'TeamOutlined' },
  { key: 'efficiency', label: '效率工具', icon: 'ThunderboltOutlined' },
];

// —— Mock 插件数据（22个） ——
const plugins = [
  // 官方推荐
  {
    id: 'p001',
    name: '新品冷启动套装',
    description: '从0到1快速冷启动新品：竞品分析→卖点提炼→Listing优化→首单转化，一站式打通上市闭环',
    category: 'featured',
    installs: 12840,
    rating: 4.9,
    priceType: 'paid',
    price: 29,
    icon: 'RocketOutlined',
    tags: ['冷启动', '选品', '上市'],
    author: 'Simon AI Lab',
    version: 'v3.2.1',
    updatedAt: '2025-03-10',
    isHot: true,
  },
  {
    id: 'p002',
    name: 'TikTok爆款视频生成器',
    description: 'AI分析TikTok趋势视频，自动生成符合平台调性的种草脚本、分镜、字幕，支持批量生产',
    category: 'featured',
    installs: 35620,
    rating: 4.8,
    priceType: 'free',
    price: 0,
    icon: 'VideoCameraOutlined',
    tags: ['TikTok', '短视频', '脚本'],
    author: 'Simon AI Lab',
    version: 'v2.8.0',
    updatedAt: '2025-03-12',
    isHot: true,
  },
  {
    id: 'p003',
    name: 'Amazon PPC智能调价',
    description: '基于ROI/ACoS目标自动调整Amazon广告出价，24小时实时监控，异常自动暂停',
    category: 'featured',
    installs: 8930,
    rating: 4.7,
    priceType: 'paid',
    price: 49,
    icon: 'AimOutlined',
    tags: ['Amazon', 'PPC', '自动调价'],
    author: 'AdTech Pro',
    version: 'v4.1.0',
    updatedAt: '2025-03-08',
    isHot: true,
  },

  // 内容创作
  {
    id: 'p004',
    name: 'Listing文案大师',
    description: 'A+Listing内容生成器，输入产品特性→输出SEO优化标题/五点描述/后台关键词',
    category: 'content',
    installs: 28450,
    rating: 4.6,
    priceType: 'free',
    price: 0,
    icon: 'EditOutlined',
    tags: ['Listing', '文案', 'SEO'],
    author: 'ContentForge',
    version: 'v2.3.5',
    updatedAt: '2025-03-05',
  },
  {
    id: 'p005',
    name: '跨平台内容适配引擎',
    description: '一次生成自动适配TikTok/Instagram/YouTube/小红书尺寸和风格的内容',
    category: 'content',
    installs: 19230,
    rating: 4.5,
    priceType: 'paid',
    price: 19,
    icon: 'SwapOutlined',
    tags: ['跨平台', '适配', '批量'],
    author: 'OmniCreator',
    version: 'v1.9.2',
    updatedAt: '2025-03-01',
  },
  {
    id: 'p006',
    name: 'AI口播脚本生成器',
    description: '根据产品信息和目标受众，自动生成类人口播脚本，支持多种情绪风格切换',
    category: 'content',
    installs: 15600,
    rating: 4.4,
    priceType: 'free',
    price: 0,
    icon: 'SoundOutlined',
    tags: ['口播', '脚本', 'AI配音'],
    author: 'VoiceCraft',
    version: 'v1.5.0',
    updatedAt: '2025-02-28',
  },
  {
    id: 'p007',
    name: 'UGC内容批量工厂',
    description: '批量生成用户风格的UGC内容模板，支持多语言、多种类融合',
    category: 'content',
    installs: 11800,
    rating: 4.3,
    priceType: 'paid',
    price: 39,
    icon: 'AppstoreOutlined',
    tags: ['UGC', '批量', '模板'],
    author: 'ContentScale',
    version: 'v2.0.1',
    updatedAt: '2025-03-09',
  },

  // 广告投放
  {
    id: 'p008',
    name: 'Meta Ads AI优化师',
    description: '自动分析Facebook/Instagram广告受众，智能分配预算，动态调整出价策略',
    category: 'advertising',
    installs: 21340,
    rating: 4.7,
    priceType: 'paid',
    price: 59,
    icon: 'FacebookOutlined',
    tags: ['Meta', '广告', '优化'],
    author: 'AdMeta Pro',
    version: 'v3.0.0',
    updatedAt: '2025-03-11',
  },
  {
    id: 'p009',
    name: 'Google Shopping自动化',
    description: '自动生成和优化Google Shopping商品Feed，智能匹配高转化搜索词',
    category: 'advertising',
    installs: 9420,
    rating: 4.5,
    priceType: 'paid',
    price: 35,
    icon: 'ShoppingOutlined',
    tags: ['Google', 'Shopping', 'Feed'],
    author: 'FeedMaster',
    version: 'v1.8.4',
    updatedAt: '2025-02-25',
  },
  {
    id: 'p010',
    name: '跨平台投放套装',
    description: 'Meta+Google+TikTok三平台统一投放策略，预算智能分配，效果横向对比',
    category: 'advertising',
    installs: 7650,
    rating: 4.8,
    priceType: 'paid',
    price: 49,
    icon: 'ClusterOutlined',
    tags: ['跨平台', '投放', '预算'],
    author: 'Simon AI Lab',
    version: 'v2.5.0',
    updatedAt: '2025-03-12',
    isHot: true,
  },

  // 数据分析
  {
    id: 'p011',
    name: '商业智能仪表盘',
    description: '多渠道数据聚合实时仪表盘：销售/广告/库存/退货率，自定义指标和告警',
    category: 'analytics',
    installs: 32100,
    rating: 4.8,
    priceType: 'paid',
    price: 39,
    icon: 'DashboardOutlined',
    tags: ['仪表盘', '可视化', '实时'],
    author: 'DataVue',
    version: 'v4.2.3',
    updatedAt: '2025-03-07',
  },
  {
    id: 'p012',
    name: '竞品价格追踪器',
    description: '7×24小时监控竞品价格变动，自动记录价格历史，触发降价/涨价比价告警',
    category: 'analytics',
    installs: 24500,
    rating: 4.6,
    priceType: 'free',
    price: 0,
    icon: 'EyeOutlined',
    tags: ['竞品', '价格', '监控'],
    author: 'PriceRadar',
    version: 'v3.1.0',
    updatedAt: '2025-03-03',
  },
  {
    id: 'p013',
    name: '关键词排名追踪',
    description: '持续追踪各平台SEO关键词排名变化，提供波动分析和关键词机会推荐',
    category: 'analytics',
    installs: 18900,
    rating: 4.5,
    priceType: 'paid',
    price: 25,
    icon: 'LineChartOutlined',
    tags: ['关键词', 'SEO', '排名'],
    author: 'SEOTracker',
    version: 'v2.7.1',
    updatedAt: '2025-03-06',
  },

  // 达人营销
  {
    id: 'p014',
    name: '达人智能匹配引擎',
    description: '基于品牌调性+预算+转化目标，AI匹配最合适的海外达人，输出分析报告',
    category: 'influencer',
    installs: 16780,
    rating: 4.7,
    priceType: 'paid',
    price: 45,
    icon: 'TeamOutlined',
    tags: ['达人', '匹配', '海外'],
    author: 'InfluMatch',
    version: 'v3.4.0',
    updatedAt: '2025-03-04',
  },
  {
    id: 'p015',
    name: 'TikTok种草套装',
    description: 'TikTok达人筛选→样品寄送→内容审核→数据回收→效果分析全流程自动化',
    category: 'influencer',
    installs: 27300,
    rating: 4.9,
    priceType: 'free',
    price: 0,
    icon: 'LikeOutlined',
    tags: ['TikTok', '种草', '全流程'],
    author: 'Simon AI Lab',
    version: 'v2.2.0',
    updatedAt: '2025-03-10',
    isHot: true,
  },
  {
    id: 'p016',
    name: '达人ROI预测器',
    description: '输入达人数据，AI预测Campaign预估CPM/CPE/转化率，辅助达人合作决策',
    category: 'influencer',
    installs: 13200,
    rating: 4.4,
    priceType: 'free',
    price: 0,
    icon: 'CalculatorOutlined',
    tags: ['ROI', '预测', '决策'],
    author: 'ROICalc',
    version: 'v1.6.2',
    updatedAt: '2025-02-20',
  },

  // 效率工具
  {
    id: 'p017',
    name: 'Listing迭代套装',
    description: 'A/B测试Listing→自动识别低效元素→AI优化文案/图片→持续迭代提升转化',
    category: 'efficiency',
    installs: 20100,
    rating: 4.6,
    priceType: 'paid',
    price: 19,
    icon: 'ExperimentOutlined',
    tags: ['A/B测试', '迭代', '优化'],
    author: 'ListLoop',
    version: 'v2.3.4',
    updatedAt: '2025-03-11',
  },
  {
    id: 'p018',
    name: '库存智能预警',
    description: '多平台库存统一管理，AI预测补货时机，断货/冗余自动告警',
    category: 'efficiency',
    installs: 22450,
    rating: 4.7,
    priceType: 'paid',
    price: 29,
    icon: 'BellOutlined',
    tags: ['库存', '预警', '补货'],
    author: 'StockMind',
    version: 'v3.0.2',
    updatedAt: '2025-03-09',
  },
  {
    id: 'p019',
    name: '客服AI自动回复',
    description: '对接Amazon/eBay/Shopify消息，AI理解买家意图，多国语言模板化回复',
    category: 'efficiency',
    installs: 31200,
    rating: 4.5,
    priceType: 'free',
    price: 0,
    icon: 'MessageOutlined',
    tags: ['客服', '自动化', '多语言'],
    author: 'ReplyBot',
    version: 'v2.9.0',
    updatedAt: '2025-03-02',
  },
  {
    id: 'p020',
    name: '翻译本地化专家',
    description: '商品描述/广告文案一键本地化翻译，适配目标市场语言习惯和搜索偏好',
    category: 'efficiency',
    installs: 26800,
    rating: 4.6,
    priceType: 'free',
    price: 0,
    icon: 'GlobalOutlined',
    tags: ['翻译', '本地化', '多语言'],
    author: 'LocalizeAI',
    version: 'v2.1.1',
    updatedAt: '2025-03-01',
  },
  {
    id: 'p021',
    name: '利润核算助手',
    description: '自动抓取广告费/仓储/FBA/退货/汇损等全链路成本，输出真实利润报表',
    category: 'efficiency',
    installs: 14500,
    rating: 4.8,
    priceType: 'paid',
    price: 35,
    icon: 'DollarOutlined',
    tags: ['利润', '核算', '报表'],
    author: 'ProfitCalc',
    version: 'v1.4.5',
    updatedAt: '2025-02-27',
  },
  {
    id: 'p022',
    name: '侵权风险扫描器',
    description: '上传产品图/Listing，自动检测商标/专利/品牌词侵权风险，输出风险评分',
    category: 'efficiency',
    installs: 17300,
    rating: 4.4,
    priceType: 'paid',
    price: 19,
    icon: 'SafetyOutlined',
    tags: ['侵权', '风险', '合规'],
    author: 'IPShield',
    version: 'v1.2.8',
    updatedAt: '2025-03-05',
  },
];

// —— 模拟延迟 ——
const delay = (ms = 200) => new Promise((r) => setTimeout(r, ms));

// —— 内存中的已安装状态（模拟） ——
let installedIds = new Set(['p002', 'p012']);

/**
 * 获取插件列表
 * @param {string} [filter] - 分类过滤 (all/featured/content/advertising/analytics/influencer/efficiency)
 */
export async function getPlugins(filter = 'all') {
  await delay();
  if (filter === 'all' || !filter) return [...plugins];
  return plugins.filter((p) => p.category === filter);
}

/**
 * 获取已安装插件
 */
export async function getInstalled() {
  await delay();
  return plugins.filter((p) => installedIds.has(p.id));
}

/**
 * 安装插件
 * @param {string} pluginId
 */
export async function install(pluginId) {
  await delay(400);
  if (!plugins.find((p) => p.id === pluginId)) {
    throw new Error('插件不存在');
  }
  installedIds.add(pluginId);
  return { success: true, pluginId };
}

/**
 * 卸载插件
 * @param {string} pluginId
 */
export async function uninstall(pluginId) {
  await delay(300);
  installedIds.delete(pluginId);
  return { success: true, pluginId };
}

/**
 * 获取分类计数
 */
export async function getCategoryCounts() {
  await delay();
  const counts = { all: plugins.length };
  for (const p of plugins) {
    counts[p.category] = (counts[p.category] || 0) + 1;
  }
  return counts;
}

/**
 * 搜索插件
 */
export async function searchPlugins(keyword) {
  await delay(150);
  if (!keyword) return [...plugins];
  const kw = keyword.toLowerCase();
  return plugins.filter(
    (p) =>
      p.name.toLowerCase().includes(kw) ||
      p.description.toLowerCase().includes(kw) ||
      p.tags.some((t) => t.toLowerCase().includes(kw))
  );
}

export default { getPlugins, install, uninstall, getInstalled, getCategoryCounts, searchPlugins, categories };
